import React from "react"
import { IconButton } from "@mui/material"
import { ZoomIn, ZoomOut } from "lucide-mui"

interface ZoomControlsProps {
  zoom: number
  onZoomIn: () => void
  onZoomOut: () => void
}

const ZoomControls: React.FC<ZoomControlsProps> = ({ zoom, onZoomIn, onZoomOut }) => {
  return (
    <div
      className="absolute bottom-4 right-4 flex items-center gap-2 bg-white rounded-lg shadow-lg border border-solid border-gray-300 p-2"
      data-testid="settings-venue-plan-editor-zoom-container"
    >
      <IconButton
        onClick={onZoomOut}
        disabled={zoom <= 100}
        size="small"
        data-testid="settings-venue-plan-editor-zoom-btn-out"
      >
        <ZoomOut className="w-5 h-5" />
      </IconButton>
      <span
        className="text-sm text-gray-600 min-w-[60px] text-center"
        data-testid="settings-venue-plan-editor-zoom-level"
      >
        {zoom}%
      </span>
      <IconButton
        onClick={onZoomIn}
        disabled={zoom >= 400}
        size="small"
        data-testid="settings-venue-plan-editor-zoom-btn-in"
      >
        <ZoomIn className="w-5 h-5" />
      </IconButton>
    </div>
  )
}

export default ZoomControls
